import { inject, Injectable } from "@angular/core";
import { ApiService } from "../ApiService";

@Injectable()
export class SearchStorageService {
  private apiService = inject(ApiService);

  storeSearch(searchType: SearchType, searchJson: string): Promise<number> {
    return this.apiService.POST<any, number>({
      SearchType: searchType,
      SearchJson: searchJson,
    }, "api/v1/users/me/searches").toPromise();
  }

  getLastSearch(searchType: SearchType): Promise<SearchRecord> {
    return this.apiService.GET<SearchRecord>(`api/v1/users/me/searches/bytype/${searchType}/latest`).toPromise();
  }

  deleteStoredSearch(id: number): Promise<void> {
    this.apiService.DELETE(`api/v1/users/me/searches/byid/${id}`);
    return;
  }
}

class SearchRecord {
  public id;
  public Name;
  public SearchJson;
  public SearchType;
}

export enum SearchType {
  Program = 1,
  Protocol = 2,
  TrialPlan = 3,
  TrialActual = 4,
  Placeholder = 5,
  NonTrial = 6,
  ResponsibilityReport = 7,
  EmailHistory = 8,
  Vendor = 9,
  Quotes = 10,
  Agreements = 11,
  Invoices = 12
}
